import { IUser } from '@app/models/user.interface';
import { createAction, props } from '@ngrx/store';

export const loadUsers = createAction(
  '[User] Load Users'
);

export const loadUsersSuccess = createAction(
  '[User] Load Users Success',
  props<{ users: IUser[], total: number }>()
);

export const loadUsersFailure = createAction(
  '[User] Load Users Failure',
  props<{ error: any }>()
);

export const loadUser = createAction(
  '[User] Load User',
  props<{id: number }>()
);

export const loadUserSuccess = createAction(
  '[User] Load User Success',
  props<{ user: any }>()
);

export const loadUserFailure = createAction(
  '[User] Load User Failure',
  props<{ error: any }>()
);

export const saveUser = createAction(
  '[User] Save User',
  props<{ user: any }>()
)

export const saveUserSuccess = createAction(
  '[User] Save User Success',
  props<{ user: any }>()
)

export const saveUserFailure = createAction(
  '[User] Save User Failure',
  props<{error: any}>()
)

export const updateUser = createAction(
  '[User] Update User',
  props<{
    id: any, 
    user: any }>()
)

export const updateUserSuccess = createAction(
  '[User] Update User Success',
  props<{ user: any }>()
)

export const updateUserFailture = createAction(
  '[User] Update User Failure',
  props<{ error: any }>()
)

export const deleteUser = createAction(
  '[User] Delete User',
  props<{
    id: any
  }>()
)

export const deleteUserSuccess = createAction(
  '[User] Delete User Success',
  props<{ id: any }>()
)

export const noDeleteUserSuccess = createAction(
  '[User] No Delete User Success',
  props<{ id: any }>()
)

export const deleteUserFailure = createAction(
  '[User] Delete User Failure'
)

export const checkUser = createAction(
  '[User] Check User',
  props<{
    name: string
  }>()
)

export const checkUserSuccess = createAction(
  '[User] Check User Success',
  props<{ valid: any }>()
)

export const checkUserFailure = createAction(
  '[User] Check User Failure'
)

export const sortUsers = createAction(
  '[User] Sort Users',
  props<{ sort: any, direction: any }>()
)

export const incrementPage = createAction(
  '[User] Increment Pagination',
  props<{ currentPage: any }>()
);

export const resetPage = createAction(
  '[User] Reset Pagination'
);

export const incrementPageSuccess = createAction(
  '[User] Increment Pagination Success',
  props<{ currentPage: any }>()
);

export const decrementPage = createAction(
  '[User] Decrement Pagination'
);

export const resetUser = createAction(
  '[User] Reset User'
);

/* Start Multilocation Actions */
export const changeToken = createAction(
  '[User] Load changeToken',
  props<{ id: number, ids:any }>()
);

export const changeTokenSuccess = createAction(
  '[User] Load changeToken Success'
);

export const changeTokenFailure = createAction(
  '[User] Load changeToken Failure',
  props<{ error: any }>()
);

/* End Multilocation Actions */